import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOrTiny,
  mediaWideNavless,
} from '@xing-com/layout-tokens';
import {
  SkeletonBodyCopy,
  SkeletonButton,
  SkeletonPillShape,
} from '@xing-com/skeleton';
import {
  scale130,
  scale230,
  scale320,
  spaceXS,
  spaceS,
  spaceM,
  spaceL,
  spaceXXL,
  space3XL,
} from '@xing-com/tokens';

const RequestReceivedContainerSkeleton = styled.div`
  padding: ${space3XL} 0;

  @media ${mediaConfined} {
    padding: ${space3XL} ${spaceXXL};
  }

  @media ${mediaWideNavless} {
    padding: ${spaceXXL} ${space3XL};
  }
`;

const RequestReceivedContactContainerSkeleton = styled.div`
  display: flex;
  gap: ${spaceL};
  margin-bottom: ${space3XL};
`;

const RequestReceivedContactCopiesContainerSkeleton = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

type RequestReceivedContactBodyCopySkeletonProps = {
  width?: string;
};

const RequestReceivedContactBodyCopySkeleton = styled(
  SkeletonBodyCopy
)<RequestReceivedContactBodyCopySkeletonProps>`
  display: block;
  padding: ${spaceXS} 0;

  &:not(:last-child) {
    margin-bottom: ${spaceL};
  }

  ${(props) =>
    props.width
      ? `
      max-width: ${props.width}
  `
      : `
      max-width: ${scale320};
  `}
`;

const RequestReceivedContactButtonsContainerSkeleton = styled.div`
  display: flex;
  flex: 0.6;
  gap: ${spaceM};
`;

const RequestReceivedContactAcceptButtonSkeleton = styled(SkeletonButton)`
  max-width: ${scale230};

  @media ${mediaSmallOrTiny} {
    max-height: ${scale130};
    max-width: ${scale130};
  }
`;

const RequestReceivedContactDeclineButtonSkeleton = styled(SkeletonButton)`
  height: ${scale130};
  max-width: ${scale130};
`;

const RequestReceivedContactSkeletonPillShapeSkeleton = styled(
  SkeletonPillShape
)`
  margin-top: ${spaceS};
`;

export const Styled = {
  RequestReceivedContainerSkeleton,
  RequestReceivedContactContainerSkeleton,
  RequestReceivedContactCopiesContainerSkeleton,
  RequestReceivedContactBodyCopySkeleton,
  RequestReceivedContactButtonsContainerSkeleton,
  RequestReceivedContactAcceptButtonSkeleton,
  RequestReceivedContactDeclineButtonSkeleton,
  RequestReceivedContactSkeletonPillShapeSkeleton,
};
